import { useContext, useState } from "react"

import getCurso from "../services/getCurso"

import { AuthContext } from "../contexts/auth"
import postCurso from "../services/postCurso"
import { useNavigate } from "react-router-dom"
import toast from "react-hot-toast"
import putCurso from "../services/putCurso"

const useCursoState = () => {

    const { signOut } = useContext(AuthContext)

    const [submit, setSubmit] = useState(false)
    const [curso, setCurso] = useState(null)
    const [nome, setNome] = useState('')
    const navigate = useNavigate()    

    const _getCurso = async (id)=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getCurso(`admin/cursos/${id}/`)
        if (result.type === 'success'){
            setNome(result.data.name)
            setCurso(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.data?.detail === 'Não encontrado.'){
            toast.error(result.data?.detail)
            navigate('/gestor/cursos') 
        }
        setSubmit(false)
    }

    const _postCurso = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let json = {
            name: nome
        }

        let nome_curso = false;
        
        if (nome !== '') {
            nome_curso = true;
        } else {
            toast.error('O campo nome não pode ser em branco.')
        }
        
        if (nome_curso){
            let result = await postCurso('admin/cursos/',json)
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
    
                    navigate('/gestor/cursos')  
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
        }
        setSubmit(false)        

    }

    const _putCurso = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)

        let json = {
            ...curso, 
            name: nome
        }

        let nome_curso = false;

        if (nome === curso.name) {
            toast.error('Você não pode alterar o curso para o mesmo nome.')
        }
        else if (nome !== '') {
            nome_curso = true;
        } else {
            toast.error('O campo nome não pode ser em branco.')
        }
        
        if (nome_curso){

            let result = await putCurso(`admin/cursos/${curso.id}/`,json)
            if (result.type === 'success'){
                if (result.data?.status){
                    result.data?.status.forEach((mensagem)=>{
                        toast.error(mensagem)
                    })
                }
                else{
                    navigate('/gestor/cursos')  
                }
            }
            else if (result.data?.code === 'token_not_valid'){
                signOut()
            }
        }
        setSubmit(false)        

    }


    return {
        submit: {value: submit, set: _getCurso},
        curso:{value:curso,set:setCurso}, 
        nome:{value:nome,set:setNome}, 
        cursoPost:{value:()=>{console.log('não implementado')},set:_postCurso},
        cursoPut:{value:()=>{console.log('não implementado')},set:_putCurso},        
    }
}

export default useCursoState;